import { FlowBaseNodeComponent } from '../components/nodes/flow-base-node/flow-base-node.component';
import { FlowNodeType } from '../enums/flow-node-type.enum';
import { FlowNodeMap } from '../models/flow-node-map.model';

export const FLOW_NODE_MAP: { [key: string]: FlowNodeMap } = {
  [FlowNodeType.GROUP]: {
    name: 'Group',
    icon: 'group_work',
    color: '#9c27b0',
    order: 100
  },
  [FlowNodeType.NODE_AS_GROUP]: {
    name: 'Node As Group',
    icon: 'location_on',
    color: '#4caf50',
    order: 101,
    componentRef: FlowBaseNodeComponent
  }
};
